var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39091 4.51627C9.09672 3.26151 10.9033 3.2615 11.6091 4.51627L16.7602 13.6738C17.4525 14.9045 16.5631 16.4251 15.1511 16.4251H4.84887C3.43686 16.4251 2.54753 14.9045 3.23978 13.6738L8.39091 4.51627ZM10.923 13.656C10.923 14.1658 10.5097 14.579 9.99992 14.579C9.49011 14.579 9.07683 14.1658 9.07683 13.656C9.07683 13.1461 9.49011 12.7329 9.99992 12.7329C10.5097 12.7329 10.923 13.1461 10.923 13.656ZM9.99992 6.27122C9.49011 6.27122 9.07683 6.68451 9.07683 7.19432V9.96359C9.07683 10.4734 9.49011 10.8867 9.99992 10.8867C10.5097 10.8867 10.923 10.4734 10.923 9.96359V7.19432C10.923 6.68451 10.5097 6.27122 9.99992 6.27122Z",
    fill: "#F59E0B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d10e24ec.svg";
export { ForwardRef as ReactComponent };